module.exports = __webpack_public_path__ + "static/img/logo_admin.cf24482.png";